import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login", { replace: true }); return; }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id });
        setUser(data.user);
        // clear the hash
        window.history.replaceState({}, document.title, "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0d1b3e] text-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="eyebrow text-[#b8892b] mb-3">Finishing sign-in</div>
        <div className="serif text-3xl">Bienvenue…</div>
      </div>
    </div>
  );
}
